import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Row, Col, Button, Input, Modal, Skeleton, Tabs, Space, DatePicker } from "antd";
import dayjs from "dayjs";
import Select from "react-select";
import WindowedSelect from "react-windowed-select";

let BASE_STATE_TIME_ENTRY = {
  client: null,
  clients_xref: null,
  job: null,
  jobs_xref: null,
  task: null,
  tasks_xref: null,
  description: null,
  comments: "",
  item: null,
  items_xref: null,
  task_status: null,
  task_statuses_xref: null,
  due_at: null,
  form_due_date: null,
  jobs_xref: null,
  owned_by: null,
  time_at: dayjs(),
};

function ModalEditTimeEntry(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalWidth, setModalWidth] = useState(1200);

  const [timeEntry, setTimeEntry] = useState(BASE_STATE_TIME_ENTRY);

  const [clients, setClients] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [tasks, setTasks] = useState([]);

  const [users, setUsers] = useState([]);
  const [billRates, setBillRates] = useState([]);
  const [items, setItems] = useState([]);
  const [taskStatuses, setTaskStatuses] = useState([]);
  const [billingStatuses, setBillingStatuses] = useState([]);

  const focusFirst = useRef(null);

  const GetClients = async () => {
    let response = await props.AxiosRequest("/api/clients/get/all");
    let mapped_clients = response.data.clients
      .map((m) => {
        return { ...m, value: m.id, label: m.name };
      })
      .sort((a, b) => (a.label > b.label ? 1 : 0));
    setClients(mapped_clients);
  };
  const GetJobs = async () => {
    let response = await props.AxiosRequest("/api/jobs/get", { client_id: timeEntry?.clients_xref });
    let mapped_jobs = response.data.jobs
      .map((m) => {
        return { ...m, value: m.id, label: m.name };
      })
      .sort((a, b) => (a.label > b.label ? 1 : 0));
    setJobs(mapped_jobs);
  };
  const GetTasks = async () => {
    if (!timeEntry?.clients_xref && !timeEntry?.jobs_xref) return;
    let response = await props.AxiosRequest("/api/tasks/get", { clients_xref: timeEntry?.clients_xref, jobs_xref: timeEntry?.jobs_xref });
    let mapped_tasks = response.data.tasks
      .map((m) => {
        return { ...m, value: m.id, label: m.description };
      })
      .sort((a, b) => (a.label > b.label ? 1 : 0));
    setTasks(mapped_tasks);
  };

  const GetTimeEntry = async () => {
    //@ZACH
    if (!props?.editTimeEntryProps?.time_id) return;
    let response = await props.AxiosRequest("/api/time-entries/get", { id: props.editTimeEntryProps.time_id });
    let time_entry = response.data.time_entries[0];
    setTimeEntry(time_entry);
  };

  const GetTaskStatuses = async () => {
    let response = await props.AxiosRequest("/api/task-statuses/get");
    let statuses = response.data.task_statuses
      .map((m) => {
        return { ...m, label: m.name, value: m.id };
      })
      .sort((a, b) => (a.label > b.label ? 1 : 0));
    setTaskStatuses(statuses);
  };

  const GetUsers = async () => {
    let response = await props.AxiosRequest("/api/users/get");
    let mapped_users = response.data.users
      .map((m) => {
        return { ...m, value: m.id, label: m.name };
      })
      .sort((a, b) => (a.label > b.label ? 1 : 0));
    setUsers(mapped_users);
  };

  const GetBillRates = async () => {
    let response = await props.AxiosRequest("/api/bill-rates/get");
    let mapped_rates = response.data.bill_rates.map((m) => {
      return { ...m, value: m.id, label: m.description };
    });
    setBillRates(mapped_rates);
  };

  const GetItems = async () => {
    let response = await props.AxiosRequest("/api/items/get");
    let mapped_items = response.data.items
      .map((m) => {
        return { ...m, value: m.id, label: m.name };
      })
      .sort((a, b) => (a.label > b.label ? 1 : 0));
    setItems(mapped_items);
  };

  const GetBillingStatuses = async () => {
    let response = await props.AxiosRequest("/api/billing-statuses/get");
    let mapped_billing_statuses = response.data.billing_statuses
      .map((m) => {
        return { ...m, value: m.id, label: m.name };
      })
      .sort((a, b) => (a.label > b.label ? 1 : 0));
    setBillingStatuses(mapped_billing_statuses);
  };

  const EditTimeEntry = async () => {
    if (
      !timeEntry.clients_xref ||
      !timeEntry.jobs_xref ||
      !timeEntry.tasks_xref ||
      !timeEntry.time_by ||
      !timeEntry.items_xref ||
      !timeEntry.billing_statuses_xref ||
      !timeEntry.time_at ||
      timeEntry.hours === null ||
      !timeEntry.task_statuses_xref
    )
      return props.MakeNotification("info", "Please fill in all required fields.");
    await props.AxiosRequest("/api/time-entries/update", { ...timeEntry });
    props.setEditTimeEntryProps({ ...props.editTimeEntryProps, open: false, refresh: true });
    setTimeEntry(BASE_STATE_TIME_ENTRY);
  };

  const CalculateBillRate = async () => {
    let calculated_bill_rate = 0;
    let bill_rate = 0;
    if (timeEntry?.user?.billing_groups_xref && timeEntry?.user && timeEntry?.items_xref) {
      let found_bill_rate = billRates.find((f) => f.billing_groups_xref === timeEntry?.user?.billing_groups_xref && f.items_xref === timeEntry?.items_xref);
      if (found_bill_rate) {
        calculated_bill_rate = found_bill_rate.bill_rate * timeEntry.hours;
        bill_rate = found_bill_rate?.bill_rate;
      }
    }
    setTimeEntry({ ...timeEntry, extended_rate: calculated_bill_rate, bill_rate: bill_rate });
  };

  const SetDefaultsFromTimeEntry = async () => {
    if (!clients || !jobs || !tasks || !billingStatuses || !taskStatuses || !users) return;
    let found_item, found_billing_status, found_user, found_task_status, found_client, found_job, found_task;
    if (timeEntry?.clients_xref) found_client = clients.find((f) => f.id === timeEntry?.clients_xref);
    if (timeEntry?.jobs_xref) found_job = jobs.find((f) => f.id === timeEntry?.jobs_xref);
    if (timeEntry?.tasks_xref) found_task = tasks.find((f) => f.id === timeEntry?.tasks_xref);
    if (timeEntry?.items_xref) found_item = items.find((f) => f.id === timeEntry?.items_xref);
    if (timeEntry?.billing_statuses_xref) found_billing_status = billingStatuses.find((f) => f.id === timeEntry?.billing_statuses_xref);
    if (timeEntry.time_by) found_user = users.find((f) => f.id === timeEntry?.time_by);
    if (!found_user) found_user = users.find((f) => f.id === timeEntry?.users_xref);
    if (timeEntry?.task_statuses_xref) found_task_status = taskStatuses.find((f) => f.id === timeEntry?.task_statuses_xref);
    setTimeEntry({
      ...timeEntry,
      client: found_client,
      job: found_job,
      task: found_task,
      item: found_item,
      billing_status: found_billing_status,
      user: found_user,
      task_status: found_task_status,
    });
  };

  useEffect(() => {
    if (!modalOpen && props.editTimeEntryProps.open) {
      GetItems();
      GetJobs();
      GetClients();
      GetUsers();
      GetBillRates();
      GetTaskStatuses();
      GetBillingStatuses();
    }
    setModalOpen(props.editTimeEntryProps.open);
  }, [props.editTimeEntryProps.open, timeEntry.owned_by]);

  useEffect(() => {
    if (timeEntry?.clients_xref) {
      GetJobs();
    }
  }, [timeEntry.clients_xref]);
  useEffect(() => {
    if (timeEntry?.jobs_xref) GetTasks();
  }, [timeEntry.jobs_xref]);

  useEffect(() => {
    if (props?.editTimeEntryProps?.time_id && props?.editTimeEntryProps?.open) GetTimeEntry();
  }, [props?.editTimeEntryProps.time_id, props.editTimeEntryProps.open]);

  useEffect(() => {
    if (timeEntry?.id) SetDefaultsFromTimeEntry();
  }, [timeEntry?.id, clients, jobs, tasks, billingStatuses, taskStatuses, users]);

  useEffect(() => {
    if (timeEntry?.owned_by && timeEntry.items_xref && billRates) CalculateBillRate();
  }, [timeEntry.owned_by, timeEntry.items_xref, billRates]);

  return (
    <>
      <Modal
        afterOpenChange={(open) => open && focusFirst.current?.focus()}
        title="Edit Time Entry"
        centered
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
          setTimeEntry(BASE_STATE_TIME_ENTRY);
          props.setEditTimeEntryProps({ ...props.editTimeEntryProps, open: false, client_id: null });
        }}
        footer={
          <>
            <Button
              onClick={() => {
                setModalOpen(false);
                setTimeEntry(BASE_STATE_TIME_ENTRY);
                props.setEditTimeEntryProps({ ...props.editTimeEntryProps, open: false, client_id: null });
              }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={EditTimeEntry}>
              Save
            </Button>
          </>
        }
        width={modalWidth}
      >
        {timeEntry ? (
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <label className="col-form-label-sm">Client *</label>
              <WindowedSelect
                value={timeEntry.client}
                isDisabled={props?.editTimeEntryProps?.editing}
                options={props.MakeClientOptions(clients)}
                onChange={(e) => {
                  setTimeEntry({ ...timeEntry, client: e, clients_xref: e.value });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm">Job *</label>
              <Select
                value={timeEntry.job}
                isDisabled={props?.editTimeEntryProps?.editing}
                options={jobs.sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0))}
                onChange={(e) => {
                  if (e.value !== timeEntry.jobs_xref) setTimeEntry({ ...timeEntry, job: e, jobs_xref: e.value, task: null, tasks_xref: null });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm">Task *</label>
              <Select
                value={timeEntry.task}
                isDisabled={props?.editTimeEntryProps?.editing}
                options={props.MakeTaskOptions(
                  tasks,
                  taskStatuses?.find((f) => f.end === 1),
                )}
                onChange={(e) => {
                  let found_item = items.find((f) => f.id === e.items_xref);
                  let found_task_status = taskStatuses.find((f) => f.id === e.task_statuses_xref);
                  let found_billing_status = null;
                  if (found_item) found_billing_status = billingStatuses.find((f) => f.id === found_item.billing_statuses_xref);
                  if (found_item && found_billing_status)
                    return setTimeEntry({
                      ...timeEntry,
                      task: e,
                      tasks_xref: e.value,
                      item: found_item,
                      items_xref: found_item.id,
                      billing_statuses_xref: found_billing_status.id,
                      billing_status: found_billing_status,
                      task_status: found_task_status,
                      task_statuses_xref: found_task_status.id,
                    });
                  setTimeEntry({ ...timeEntry, task: e, tasks_xref: e.value });
                }}
              />
            </Col>
            <Col span={24}>
              <hr />
            </Col>

            <Col span={8}>
              <label className="col-form-label-sm">Time By *</label>
              <Select
                value={timeEntry.user}
                options={props.MakeUserOptions(users)}
                onChange={(e) => {
                  let calculated_bill_rate = 0;
                  let bill_rate = 0;
                  if (timeEntry?.user?.billing_groups_xref && e && timeEntry.item) {
                    let found_bill_rate = billRates.find((f) => f.billing_groups_xref === e.billing_groups_xref && f.items_xref === timeEntry.items_xref);
                    if (found_bill_rate) {
                      calculated_bill_rate = found_bill_rate.bill_rate * timeEntry.hours;
                      bill_rate = found_bill_rate?.bill_rate;
                    }
                  }
                  setTimeEntry({ ...timeEntry, user: e, time_by: e.value, extended_rate: calculated_bill_rate, bill_rate: bill_rate });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm">Item *</label>
              <Select
                value={timeEntry.item}
                options={items}
                onChange={(e) => {
                  let calculated_bill_rate = 0;
                  let bill_rate = 0;
                  if (timeEntry?.user?.billing_groups_xref && e && timeEntry.item) {
                    let found_bill_rate = billRates.find((f) => f.billing_groups_xref === timeEntry.user.billing_groups_xref && f.items_xref === e.value);
                    if (found_bill_rate) {
                      calculated_bill_rate = found_bill_rate.bill_rate * timeEntry.hours;
                      bill_rate = found_bill_rate?.bill_rate;
                    }
                  }
                  let found_billing_status = billingStatuses.find((f) => f.id === e.billing_statuses_xref);
                  setTimeEntry({
                    ...timeEntry,
                    item: e,
                    items_xref: e.value,
                    extended_rate: calculated_bill_rate,
                    bill_rate: bill_rate,
                    billing_status: found_billing_status,
                    billing_statuses_xref: e.billing_statuses_xref,
                  });
                }}
              />
            </Col>
            <Col span={8}>
              <label className="col-form-label-sm">Task Status *</label>
              <Select
                value={timeEntry.task_status}
                options={taskStatuses}
                onChange={(e) => {
                  setTimeEntry({ ...timeEntry, task_status: e, task_statuses_xref: e.value });
                }}
              />
            </Col>
            <Col span={24}>
              <label className="col-form-label-sm">Comments</label>
              <Input.TextArea
                ref={focusFirst}
                value={timeEntry.comments}
                onChange={(e) => {
                  setTimeEntry({ ...timeEntry, comments: e.target.value });
                }}
              />
            </Col>

            <Col span={6}>
              <label className="col-form-label-sm">Date of Work *</label>
              <DatePicker
                format={"MM/DD/YYYY"}
                style={{ width: "100%" }}
                allowClear={false}
                value={timeEntry?.time_at ? dayjs(timeEntry?.time_at) : null}
                onChange={(e) => {
                  setTimeEntry({ ...timeEntry, time_at: e });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Hours *</label>
              <Input
                type="number"
                value={timeEntry.hours}
                onChange={(e) => {
                  let calculated_bill_rate = 0;
                  let bill_rate = 0;
                  if (timeEntry?.user?.billing_groups_xref && e && timeEntry.item) {
                    let found_bill_rate = billRates.find((f) => f.billing_groups_xref === timeEntry.user.billing_groups_xref && f.items_xref === timeEntry.items_xref);
                    if (found_bill_rate) {
                      calculated_bill_rate = found_bill_rate.bill_rate * e.target.value;
                      bill_rate = found_bill_rate.bill_rate;
                    }
                  }
                  setTimeEntry({ ...timeEntry, hours: e.target.value, extended_rate: calculated_bill_rate, bill_rate: bill_rate });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Billing Status *</label>
              <Select
                type="number"
                options={billingStatuses}
                value={timeEntry.billing_status}
                onChange={(e) => {
                  setTimeEntry({ ...timeEntry, billing_status: e, billing_statuses_xref: e.value });
                }}
              />
            </Col>
            <Col span={6}>
              <label className="col-form-label-sm">Bill Rate</label>
              <Input readOnly prefix="$" disabled value={timeEntry.bill_rate} />
            </Col>
          </Row>
        ) : (
          <Skeleton active />
        )}
      </Modal>
    </>
  );
}

export default ModalEditTimeEntry;
